export const sortItems = (items: string[]) =>
  items
    .sort((a, b) => {
      if (a > b) return 1;
      else if (a < b) return -1;
      return 0;
    })
    .filter((item) => item);
